import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { HttpParams } from "@angular/common/http";
import * as CONSTANT from "../../../services/constants";
import swal from "sweetalert2";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-add-users-group",
  templateUrl: "./add-users-group.component.html",
  styleUrls: ["./add-users-group.component.css"]
})
export class AddUsersGroupComponent implements OnInit {
  groupPermissionId:any;
  usersData:any=[];
  currentPage = 1;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  sortType: any;
  sortBy : string = ""
  orderBy: string = "2";
  search="";
  closeSearch:boolean = false;
  showError:boolean = false;
  selectedUserIds:any = [];
  isChecked

  constructor(private toastrService: ToastrService,public route: ActivatedRoute, private router: Router,private api: AdminService) { }

  ngOnInit(): void {
    this.groupPermissionId = this.route.snapshot.paramMap.get("grpPerId");
    this.getAllUsers();
  }

  getAllUsers(){
    let params = new HttpParams();
    // params = params.append("isArchive", 0);
    params = params.append("id", this.groupPermissionId);
    params = params.append("skip", this.currentPage);
    params = params.append("limit", this.pagination.limit.toString());
    if (this.search != null && this.search != "") {
      params = params.append("search", this.search);
    }
    this.api.getData(apiUrl._manageUsersDetail, params).subscribe(
      async (res) => {
        this.usersData = res.data.users;
      },
      (err) => {
        console.log(err.error.message, "error");
      }
    );
  }

  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getAllUsers();
  }
  searchFun() {  
    this.currentPage = 1;
    this.pagination.skip = 0; 
    this.closeSearch = true; 
    this.getAllUsers(); 
    }
  clearSearch() {
    this.search= "";
    this.closeSearch = false;
    this.pagination.skip = 0; 
    localStorage.removeItem("type-redirect");
    this.getAllUsers();
  }
  
  goToBack(){
    this.router.navigate(["/groups/manage-users/" + this.groupPermissionId]);
  }

  goToUserDetail(id){
    this.router.navigate(["/users/detail/" + id]);
  }

  getIds(i){
    this.usersData[i].select = this.usersData[i].select == 0 ? 1 : 0
  }

  updateUsers(){
    if(this.usersData.length > 0){
    let selectedUserIds =  this.usersData.map((x)=>({"recruiterUserId": x.id, "select": x.select }));
    const data = {
      "groupPermissionId": this.groupPermissionId,
      "userIds": selectedUserIds
    }
    this.api.postData(apiUrl._manageUsers, data).subscribe(() => {
      this.toastrService.success("Added Successfully");
			this.router.navigate(["/groups/manage-users/" + this.groupPermissionId]);
		})} else{
      this.showError= true;
      setTimeout(() => {
      this.showError= false;
      }, 3000);
    }
  }

  goToLinkedInUrl(url){
    window.open(url,"_blank")
  }
}
